import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Grid from 'web-library/stories/atom/Grid/Grid';
import Box from 'web-library/stories/atom/Box/Box';
import KeyValue from 'web-library/stories/molecule/KeyValue/KeyValue';
import MUIDataTable from 'web-library/stories/organism/DataTable/DataTable';
import FormHeader from '../../../components/form-items/FormHeader';
import { ExamReviewResponse } from '../../../api/candidate/exam/model';
import ReviewSubjectDataColumn from '../../../components/datatables/ReviewSubjectDataColumn';
import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  container: {
    marginBottom: theme.spacing(3),
  },
  subject: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
  },
  subjectName: {
    paddingBottom: theme.spacing(1),
  },
  optionalPaper: {
     ...typographyTheme(theme, 'subtitle2'),
    color: theme.color.text.textSecondary,
  },
  gridContainer: {
    marginBottom: theme.spacing(4),
  },
  priceGrid: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  feeCell: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  feeHeader: {
    textAlign: 'right',
     ...typographyTheme(theme, 'h6'),
  },
}));
//

const ExamReviewSubjects = (props: ExamReviewResponse) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { selectedSubjects = [], examYear, payment, className } = props;

  return (
    <Grid className={`${classes.container} ${className}`}>
      <FormHeader title={t('exam->>ReviewExam.Selected Subject(s) and Exam Fees')} />

      <Grid container xs={12}>
        <Grid xs={12} sm={6} md={4} container direction="column">
          <KeyValue
            id="examYear"
            keyText={t('components->> SelectedSubjects.Exam Year')}
            valueText={examYear.toString()}
          />
        </Grid>
      </Grid>
      <Grid className={classes.gridContainer} xs={12}>
        <Box id="selected-subject-table">
          <MUIDataTable
            columns={ReviewSubjectDataColumn({
              dataContent: selectedSubjects,
              t,
              classes,
              payment,
            })}
            data={selectedSubjects}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
export default ExamReviewSubjects;
